import { createFileRoute, useParams } from '@tanstack/react-router';
import { VideoContainer } from '@components/VideoContainer';

export const Route = createFileRoute('/seeme/$sessionId/$attendeeId')({
  component: Seeme,
});

function Seeme() {
  const { sessionId, attendeeId } = useParams({
    from: '/seeme/$sessionId/$attendeeId',
  });

  return <VideoContainer sessionId={sessionId} attendeeId={attendeeId} />;
}
